import React, { useEffect, useState } from "react";
import { getUserDetails } from "../../../../../api/lead";
import "./created-by-filter.scss";
import MultiSelectAutocomplete from "../../../../../common/components/autocomplete-component/autocomplete";
interface LeadOwnerOption {
  value: number;
  label: string;
}

interface LeadOwnerFilterProps {
  value: number[];
  onChange: (value: number[]) => void;
  isLeadOwnerEnabled?: boolean;
  leadOwnerIdsError?: any;
  setAlertMessage: any;
  setAlertType: any;
  setAlertOpen: any;
}

const LeadOwnerFilter: React.FC<LeadOwnerFilterProps> = ({
  value,
  onChange,
  isLeadOwnerEnabled,
  leadOwnerIdsError,
  setAlertMessage,
  setAlertType,
  setAlertOpen
}) => {
  const [options, setOptions] = useState<LeadOwnerOption[]>([]);

  useEffect(() => {
    if (!isLeadOwnerEnabled) return;

    const fetchLeadOwnerOptions = async () => {
      try {
        const response = await getUserDetails({}, "Lead Capture");
        const data = response.data.data.data.data;
        const formattedOptions = data.map((owner: any) => ({
          value: owner.id,
          label: `${owner.username}`,
        }));

        setOptions([...formattedOptions]);
      } catch (error: any) {
        setAlertMessage(error?.response?.data?.message || "Something went wrong please try again.");
        setAlertType("error");
        setAlertOpen(true);
      }
    };

    fetchLeadOwnerOptions();
  }, [isLeadOwnerEnabled]);

  if (!isLeadOwnerEnabled) return null;



  return (
    <div className="filter-select-input-wrapper">
      <MultiSelectAutocomplete
        options={options}
        selectedValues={value}
        onChange={onChange}
        placeholder="Select Lead Owner"
      />
      {leadOwnerIdsError && <div className="error-text">{leadOwnerIdsError}</div>}
    </div>


  );
};

export default LeadOwnerFilter;
